<div
  class="terminal-gate-wrapper"
  [style.left.px]="left"
  [style.z-index]="zIndex"
  [id]="terminalUid"
  style="display: none"
>
  <div class="terminal-gate">
    <div class="flex align-items-center justify-content-between gap-20">
      <div class="terminal-name-abbrevation-container">
        <div class="text-style">
          <strong class="text-style"> Gate </strong>
        </div>
      </div>

      <div class="close-button" (click)="closeClicked()">X</div>
    </div>
    <div>
      <div class="imod-data-table ioh-gate-info" #iohGateInfoContainer>
        <p-table
          [value]="gateInfo"
          [scrollable]="false"
          responsiveLayout="stack"
        >
          <ng-template pTemplate="body" pTemplate="body" let-product>
            <tr>
              <td>In</td>
              <td class="right-cell">
                {{ gateResponse?.inGate || 0 }}
              </td>
            </tr>
            <tr>
              <td>Out</td>
              <td class="right-cell">
                {{ gateResponse?.outGate || 0 }}
              </td>
            </tr>
            <tr>
              <td>Total Moves</td>
              <td class="right-cell">
                {{ gateResponse?.totalMoves || 0 }}
              </td>
            </tr>
            <tr>
              <td>Avg. Turn Time</td>
              <td
                class="right-cell"
                [ngClass]="
                  gateResponse?.avgTurnTimeMinutes > env.appConfig.iohGateAvgTurnTimeMints
                    ? 'bg-danger'
                    : 'bg-success'
                "
              >
                {{ gateResponse?.avgTurnTimeMinutes || 0 }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr class="ioh-no-records-found">
              <td [attr.colspan]="2" class="text-center">No Records Found</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
